export const ZOOM_LEVELS = [0.5, 1, 2, 4, 8] as const;

export const TIMELINE_CONFIG = {
  pixelsPerSecond: 50,
  minSegmentDuration: 0.5,
  trackHeight: 80,
  rulerHeight: 32,
  handleWidth: 8,
  jointMarkerWidth: 32,
} as const;

export const SEGMENT_COLORS = {
  default: '#73CB87',
  innerShadow: 'rgba(10, 132, 81, 1)',
} as const;

export const EXTERNAL_SEGMENT_COLORS = {
  default: '#9C74FF',
  innerShadow: 'rgba(94, 51, 199, 1)',
} as const;
